import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

import PageHeader from 'components/general/pageHeader';

import TaskContentSection from './components/taskContentSection';
import ManageTask from '../components/manageTask';

import { pageViewed, setPrismMenu } from 'actions/ui';

import { Loading, SystemText, DebugInfo } from 'e4shared';
import { apiGet } from 'services';
import { UserMenu } from 'components/user/menu';

import { getPermissions } from 'helpers/permissions';

export const UserTask = ({ match, history }) => {
    const { user, coaching, downline } = useSelector(state => state.user);
    const isPrism = user.companySettings?.prism_UI;
    const { taskId } = match.params;

    const [profile, setProfile] = React.useState(null);
    const [task, setTask] = React.useState(null);
    const [showManageTask, setShowManageTask] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [permissions, setPermissions] = React.useState(getPermissions());

    const dispatch = useDispatch();

    const api = {
        loadProfile: id => apiGet(`profile/${id}`, user.guid, response => setProfile(response)),
        loadTask: (taskId, refresh) =>
            apiGet(
                `profile/-1/task/${taskId}${refresh ? '?refresh=true' : ''}`,
                user.guid,
                response => {
                    if (response.completed_Video_Asset?.insights_Id) {
                        response.insights_Id = response.completed_Video_Asset.insights_Id;
                        response.insights = response.completed_Video_Asset.insights
                            ? JSON.parse(response.completed_Video_Asset.insights)
                            : null;
                        response.video = response.insights?.videos ? response.insights.videos[0] : { insights: {} };
                    }

                    setTask(response);
                    api.loadProfile(response.profile_Id);
                },
                () => setError(true)
            ),
        pageViewed: view => dispatch(pageViewed(view)),
    };

    React.useEffect(() => {
        DebugInfo('component', 'UserTask');
        DebugInfo('task-id', taskId);
    }, []);

    React.useEffect(() => {
        if (profile?.id && user?.id) {
            setPermissions(getPermissions(profile, user, coaching, downline));

            if (isPrism) {
                if (profile.id === user.id) {
                    dispatch(setPrismMenu('Objectives'));
                } else {
                    dispatch(setPrismMenu('MyTeam'));
                }
            }
        }
    }, [profile?.id, user?.id]);

    React.useEffect(() => {
        api.loadTask(taskId);
        api.pageViewed({ type: 'OBJ', type_Id: taskId });
    }, []);

    React.useEffect(() => {
        if (task && profile) {
            setLoading(false);
        } else {
            setLoading(true);
        }
    }, [profile, task]);

    if (error) {
        history.replace('/error');
    }

    if (loading || !task) {
        return <Loading />;
    }

    if (task.appraisal_Id) {
        // if prism, then is it my review or team members review as the destination needs to change
        if (isPrism) {
            if (user.id === task.appraisal_Id) {
                history.replace(`/develop/reviews`);
            } else {
                //currently we can send the user to reviews but the task does not have the actual appraisal_id just the profile_id
                history.replace(`/team-member/${task.appraisal_Id}?tab=reviews`);
            }
        } else {
            history.replace(`/develop/reviews/${task.appraisal_Id}?oid=${task.date_Completed ? '' : task.id}`);
        }
    }

    const text = {
        title: SystemText('Objective/Title'),
        crumb: SystemText('Objective/Crumb'),
        buttons: {
            edit: SystemText('Objective/Buttons/Edit'),
        },
    };

    const editButton = () => (
        <div className="flex">
            {permissions.objectives.canEdit?.(task.owner_Id) && (
                <button
                    data-testid="edit-objective-button"
                    className="btn btn-success"
                    onClick={() => setShowManageTask(true)}
                >
                    <i className="fa fa-pencil mr10" />
                    {text.buttons.edit}
                </button>
            )}
            <UserMenu history={history} profile={profile} user={user} />
        </div>
    );

    const crumb = {
        label: text.crumb,
        link: `/objectives/${profile.id}`,
    };

    return (
        <div>
            <PageHeader title={text.title} overrideProfile={profile} extra={editButton} crumb={crumb} />

            <TaskContentSection task={task} setTask={setTask} profile={profile} />

            <ManageTask
                show={showManageTask}
                values={{
                    ...task,
                }}
                disableProfileEdit
                reload={() => {
                    api.loadTask(taskId, true);
                }}
                close={() => {
                    setShowManageTask(false);
                }}
            />
        </div>
    );
};

export default withRouter(UserTask);
